"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/hubController',["require", "exports", "providers/ajaxSettingsProvider", "controllers/abortingRequest"], function (require, exports, ajaxSettingsProvider, abortingRequest) {
    "use strict";

    var HubController = function () {
        function HubController() {
            _classCallCheck(this, HubController);
        }

        _createClass(HubController, [{
            key: "getHubAccess",
            value: function getHubAccess(data) {
                return abortingRequest.send('/api/Hubs/GetHubAccess', ajaxSettingsProvider.httpPost(data), true, false);
            }
        }]);

        return HubController;
    }();

    return new HubController();
});
//# sourceMappingURL=hubController.js.map;
